/**
 * PendingReports Modal component module.
 * @module shared/components/modals/content/PendingReports
 *
 */

import React, {Component} from 'react';
import {connect} from 'react-redux';
import BaseModal from '../types/Base';
import {_removeModal} from '../../../store';
import PropTypes from 'prop-types';
import Tabs from '../../Tabs';
import Table from '../../Table';
import axiosInstance from '../../../utils/axios';
import debug from 'debug';

const log = debug('circleblack:pending-reports-modal');

/**
 * PendingReports component
 * @name PendingReports
 */
class PendingReports extends Component {
  constructor(props) {
    super(props);
    this.state = {content: props.content};

    this.pendingDataManager = {
      gatherData: this.getDocuments({status: ['!6', '!7', '!8'], isNull: 'errorID'}),
    };
    this.failedDataManager = {
      gatherData: this.getDocuments({isNotNull: 'errorID'}),
    };
  }

  getDocuments = statuses => filter => {
    log('gathering documents');
    return axiosInstance.get('reports/documents', {params: {...statuses, ...filter}})
      .then(res => res.data);
  };

  renderTable = dataManager => (
    <Table dataManager={dataManager}
           columns={[
             {
               title: 'Owner',
               dataPoint: 'requestor',
               type: 'text',
               minWidth: 50,
               isSortable: true,
             },
             {
               title: 'Type',
               dataPoint: 'reportName',
               type: 'text',
               minWidth: 50,
               isSortable: true,
             },
             {
               title: 'Level',
               dataPoint: 'level',
               type: 'text',
               minWidth: 50,
               isSortable: true,
             },
             {
               title: 'Target Context',
               dataPoint: 'targetContext',
               type: 'text',
               minWidth: 50,
               isSortable: true,
             },
             {
               title: 'Status',
               dataPoint: 'status',
               type: 'text',
               minWidth: 50,
               isSortable: true,
             },
             {
               title: 'Requested',
               dataPoint: 'requestedAt',
               type: 'datetime',
               minWidth: 50,
               isSortable: true,
             },
           ]}
           defaultSort={{
             column: 'requestedAt',
             desc: true,
           }}
           height={'300px'}/>);

  render() {
    const {content} = this.state;
    const {dispatchRemoveModal} = this.props;
    const pendingTab = {
      title: 'Pending',
      icon: null,
      content: this.renderTable(this.pendingDataManager),
    };
    const failedTab = {
      title: 'Failed',
      icon: null,
      content: this.renderTable(this.failedDataManager),
    };
    const tabs = [pendingTab, failedTab];
    return (
      <BaseModal onClose={() => dispatchRemoveModal(content)} title={'Pending Reports'} size={'lg'}>
        <Tabs tabs={tabs} displayTabTitles={true} minTabWidth={'50'} tabWidth={'500'} defaultSelection={0}/>
      </BaseModal>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  dispatchRemoveModal: modal => dispatch(_removeModal(modal)),
});

export default connect(null, mapDispatchToProps)(PendingReports);

PendingReports.propTypes = {
  /**
   * The remove modal function that dispatches _removeModal from Redux
   */
  dispatchRemoveModal: PropTypes.func.isRequired,
  /**
   * content openModal is called with
   */
  content: PropTypes.shape({
    /**
     * id from derived from (modal.type || modal.componentName) + '-' + uuid.v4()
     */
    id: PropTypes.string.isRequired,
    /**
     * componentName of the modal
     */
    componentName: PropTypes.string.isRequired,
  }),
};
